import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function PortfolioSection() {
  return <section id="portfolio" className="py-32 px-6 md:px-12 max-w-7xl mx-auto border-t border-avm-border" data-id="element-122">
      <div className="mb-20" data-id="element-123">
        <span className="text-avm-accent text-xs font-semibold tracking-[0.2em] uppercase mb-6 block" data-id="element-124">
          Portfolio
        </span>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-avm-text" data-id="element-125">
          Current Operations
        </h2>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }} className="group relative border border-avm-border bg-avm-bgAlt p-8 md:p-16 hover:border-avm-borderHover transition-colors duration-500" data-id="element-126">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-24 items-start lg:items-center" data-id="element-127">
          <div className="flex-1" data-id="element-128">
            <div className="flex items-center gap-4 mb-8" data-id="element-129">
              <h3 className="font-serif text-4xl md:text-5xl text-avm-text" data-id="element-130">
                MeatMarket.AI
              </h3>
              <div className="flex items-center gap-2 px-3 py-1 border border-avm-border rounded-full bg-avm-bg" data-id="element-131">
                <div className="w-2 h-2 rounded-full bg-green-500/80" data-id="element-132"></div>
                <span className="text-xs font-medium text-avm-textMuted uppercase tracking-wider" data-id="element-133">
                  Active
                </span>
              </div>
            </div>

            <p className="text-lg md:text-xl text-avm-textMuted font-light leading-relaxed mb-10" data-id="element-134">
              A wholesale protein intelligence platform delivering structured
              pricing datasets, interactive dashboards, and AI-assisted market
              analysis across beef, pork, and chicken markets.
            </p>

            <div className="flex flex-wrap gap-3 mb-10 lg:mb-0" data-id="element-135">
              {['Market Intelligence', 'AI Analytics', 'Wholesale Protein'].map(tag => <span key={tag} className="text-xs font-medium tracking-wide text-avm-textMuted px-4 py-2 border border-avm-border bg-avm-bg" data-id="element-136">
                    {tag}
                  </span>)}
            </div>
          </div>

          <div className="lg:w-1/3 flex justify-start lg:justify-end w-full" data-id="element-137">
            <a href="https://meatmarket.ai" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-avm-text hover:text-avm-accent transition-colors duration-300 group/btn pb-1 border-b border-transparent hover:border-avm-accent" data-id="element-138">
              <span className="font-medium tracking-wide" data-id="element-139">Learn More</span>
              <ArrowRightIcon className="w-4 h-4 transform group-hover/btn:translate-x-1 transition-transform" data-id="element-140" />
            </a>
          </div>
        </div>
      </motion.div>
    </section>;
}